import { render, staticRenderFns } from "./ViewRewards.vue?vue&type=template&id=80b502fe&scoped=true"
import script from "./ViewRewards.vue?vue&type=script&lang=js"
export * from "./ViewRewards.vue?vue&type=script&lang=js"
import style0 from "./ViewRewards.vue?vue&type=style&index=0&id=80b502fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b502fe",
  null
  
)

export default component.exports